import { apiClient, handleApiError, createSuccessResponse } from "./api";

const budgetService = {
  /**
   * @function listBudget
   * @description Lista todos os orçamentos
   * @returns {Promise<Object>} - Resposta da API com estrutura de sucesso
   */
  async listBudget() {
    try {
      const response = await apiClient.get("/tasks");
      return response.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  /**
   * @function searchBudget
   * @description Busca orçamentos com base nos filtros fornecidos usando o novo endpoint
   * @param {string} queryString - String de query com os parâmetros de busca
   * @returns {Promise<Object>} - Resposta da API com estrutura de paginação
   */
  async searchBudget(queryString) {
    try {
      const endpoint = queryString
        ? `/budget?${queryString}`
        : "/budget";
      const response = await apiClient.get(endpoint);

      return response.data;
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  /**
   * @function findBudgetById
   * @description Busca um orçamento pelo ID
   * @param {string} idbudget - ID do orçamento
   * @returns {Promise<Object>} - Resposta da API com estrutura de sucesso
   */
  async findBudgetById(idbudget) {
    try {
      const response = await apiClient.get(`/budget/${idbudget}`);
      return createSuccessResponse(
        response.data,
        response.status,
        response.message
      );
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  /**
   * @function delete
   * @description Deleta um orçamento
   * @param {string} idbudget - ID do orçamento
   * @returns {Promise<Object>} - Resposta da API com estrutura de sucesso
   */
  async delete(idbudget) {
    try {
      const response = await apiClient.delete(`/budget/${idbudget}`);
      return createSuccessResponse(
        response.data,
        response.status,
        response.message
      );
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  /**
   * @function updateTaskPosition
   * @description Atualiza a posição de uma tarefa
   * @param {string} taskId - ID da tarefa
   * @param {string} targetColumnId - ID da coluna
   * @returns {Promise<Object>} - Resposta da API com estrutura de sucesso
   */
  async updateTaskPosition(taskId, targetColumnId) {
    try {
      const response = await apiClient.put("/update-task-position", {
        taskId,
        targetColumnId,
      });
      console.log(response);
      return createSuccessResponse(
        response.data,
        response.status,
        response.message
      );
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  /**
   * @function archiveTask
   * @description Arquiva um orçamento
   * @param {string} idbudget - ID do orçamento
   * @returns {Promise<Object>} - Resposta da API com estrutura de sucesso
   */
  async archiveTask(idbudget) {
    try {
      const response = await apiClient.put(`/budget/${idbudget}/archive`);
      return createSuccessResponse(
        response.data,
        response.status,
        response.message
      );
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  /**
   * @function unarchiveTask
   * @description Desarquiva um orçamento
   * @param {string} idbudget - ID do orçamento
   * @returns {Promise<Object>} - Resposta da API com estrutura de sucesso
   */
  async unarchiveTask(idbudget) {
    try {
      const response = await apiClient.put(`/budget/${idbudget}/unarchive`);
      return createSuccessResponse(
        response.data,
        response.status,
        response.message
      );
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },
};

export default budgetService;
